<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect :width="width" :height="height" rx="20"/>
    <path class="call_stroke_hoverEffect" d="M16.2468 20.738V16.2464H20.7385" stroke="#80B7FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path class="call_stroke_hoverEffect" d="M20.738 33.7542H16.2464V29.2625" stroke="#80B7FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path class="call_stroke_hoverEffect" d="M16.248 16.2461L22.2369 22.235" stroke="#80B7FF" stroke-width="2" stroke-linecap="round"/>
    <path class="call_stroke_hoverEffect" d="M16.2461 33.752L22.235 27.7631" stroke="#80B7FF" stroke-width="2" stroke-linecap="round"/>
    <path class="call_stroke_hoverEffect" d="M33.7542 29.262L33.7542 33.7536L29.2625 33.7536" stroke="#80B7FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path class="call_stroke_hoverEffect" d="M29.263 16.2458L33.7546 16.2458L33.7546 20.7375" stroke="#80B7FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path class="call_stroke_hoverEffect" d="M33.7529 33.7539L27.764 27.765" stroke="#80B7FF" stroke-width="2" stroke-linecap="round"/>
    <path class="call_stroke_hoverEffect" d="M33.7549 16.248L27.766 22.2369" stroke="#80B7FF" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.callIcon }
  },
  name: "IconCallExpand"
}
</script>

<style scoped>
rect{
    fill: var(--backgroundColor);
}
</style>
